import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "p-signup-profile l-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-signup-profile__ttl c-ttl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-signup-profile__ttl__logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "SHUEISHA ID"
    })
  ]),
  /*#__PURE__*/_createTextVNode("会員情報登録")
], -1)
const _hoisted_3 = { class: "p-signup-profile__field-container" }
const _hoisted_4 = { class: "p-errors" }
const _hoisted_5 = { class: "c-error" }
const _hoisted_6 = { style: {"flex-wrap":"wrap"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("既に基本属性情報が登録されています。")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "こちら", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("からログインしてください。")
const _hoisted_10 = { class: "p-fields p-fields--confirm" }
const _hoisted_11 = { class: "c-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "プロフィール画像", -1)
const _hoisted_13 = { class: "c-field__body" }
const _hoisted_14 = { class: "upload-img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "c-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "お名前", -1)
const _hoisted_18 = { class: "c-field__body" }
const _hoisted_19 = { class: "c-field" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "ふりがな", -1)
const _hoisted_21 = { class: "c-field__body" }
const _hoisted_22 = { class: "c-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "ニックネーム", -1)
const _hoisted_24 = { class: "c-field__body" }
const _hoisted_25 = { class: "c-field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "性別", -1)
const _hoisted_27 = { class: "c-field__body" }
const _hoisted_28 = { class: "c-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "誕生日", -1)
const _hoisted_30 = { class: "c-field__body" }
const _hoisted_31 = { class: "c-field" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "結婚の有無", -1)
const _hoisted_33 = { class: "c-field__body" }
const _hoisted_34 = { class: "c-field" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "子供の有無", -1)
const _hoisted_36 = { class: "c-field__body" }
const _hoisted_37 = { class: "c-field" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "血液型", -1)
const _hoisted_39 = { class: "c-field__body" }
const _hoisted_40 = { class: "c-field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "郵便番号", -1)
const _hoisted_42 = { class: "c-field__body" }
const _hoisted_43 = { class: "c-field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "都道府県", -1)
const _hoisted_45 = { class: "c-field__body" }
const _hoisted_46 = { class: "c-field" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "住所", -1)
const _hoisted_48 = { class: "c-field__body" }
const _hoisted_49 = { class: "c-field" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "電話番号", -1)
const _hoisted_51 = { class: "c-field__body" }
const _hoisted_52 = { class: "c-field" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "規約/ガイドライン", -1)
const _hoisted_54 = { class: "c-field__body" }
const _hoisted_55 = { class: "c-field has-submit has-mt" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", null, "登録する", -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", null, "入力画面に戻る", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("p", { class: "c-error" }, _toDisplayString(_ctx.errorMsgRef), 513), [
          [_vShow, _ctx.errorMsgRef]
        ]),
        _withDirectives(_createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_router_link, {
              to: { name: 'Login' },
              class: "c-link c-link--primary"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9
          ])
        ], 512), [
          [_vShow, _ctx.isDispErrorMsgRef]
        ])
      ], 512), [
        [_vShow, _ctx.errorMsgRef || _ctx.isDispErrorMsgRef]
      ]),
      _createElementVNode("fieldset", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", null, [
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("img", {
                  src: _ctx.image.path ? _ctx.image.path : require('@/assets/images/common/img_user-default.svg'),
                  alt: "Upload image"
                }, null, 8, _hoisted_15)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.lastName), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.firstName), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.lastKana), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.firstKana), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", null, _toDisplayString(_ctx.nickName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", null, _toDisplayString(_ctx.userBase.commonAttrInfo.gender === "無回答" ? "回答しない" : _ctx.userBase.commonAttrInfo.gender), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("p", null, [
              _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.year) ? "" : _ctx.date.year + "年"), 1),
              _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.month) ? "" : _ctx.date.month + "月"), 1),
              _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.day) ? "" : _ctx.date.day + "日"), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.isMarried === null) ? "" : (_ctx.userBase.commonAttrInfo.isMarried) ? "既婚" : "未婚"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.hasChild === null) ? "" : (_ctx.userBase.commonAttrInfo.hasChild) ? "有り" : "無し"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.bloodType === null || _ctx.userBase.commonAttrInfo.bloodType === "") ? "" : (_ctx.userBase.commonAttrInfo.bloodType === "不明") ? "不明" : _ctx.userBase.commonAttrInfo.bloodType + "型"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.zipCode), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.prefecture), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("p", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.address), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.building), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.tel), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("p", null, _toDisplayString(_ctx.agreement ? "集英社ID利用規約、集英社 プライバシーガイドラインに同意する。" : "集英社ID利用規約、集英社 プライバシーガイドラインに同意しない。"), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("button", {
            type: "button",
            class: "c-btn is-submit",
            disabled: _ctx.isDeterringRef,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.register, this)))
          }, _hoisted_58, 8, _hoisted_56),
          _createVNode(_component_router_link, {
            to: { name: 'SignupProfile' },
            class: _normalizeClass(["c-btn c-btn--outline", { 'is-disabled':_ctx.isDeterringRef }])
          }, {
            default: _withCtx(() => [
              _hoisted_59
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ])
    ])
  ]))
}